export function isConnected (state) {
  return state.isConnected
}
